<template>
    <div class="p-3">
        <h3>Pasien Check-In</h3>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_dari" class="col-sm-4 col-form-label text-end">Dari</label>
                    <div class="col-sm-8">
                        <input type="date" name="tanggal_dari" id="tanggal_dari" class="form-control" v-model="filter.tanggal_dari">
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_sampai" class="col-sm-4 col-form-label text-end">Sampai</label>
                    <div class="col-sm-8">
                        <input type="date" name="tanggal_sampai" id="tanggal_sampai" class="form-control" v-model="filter.tanggal_sampai">
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="mb-3 row">
                    <label for="search" class="col-sm-6 col-form-label text-end">No. RM/Nama/NIK/No Kartu BPJS</label>
                    <div class="col-sm-6">
                        <input type="text" name="search" id="search" class="form-control" v-model="filter.search">
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-danger" @click="resetFilters"><i class="fa fa-refresh"></i> Reset</button>
                        <button class="btn btn-primary" @click="getAllPasien"><i class="fa fa-search"></i> Cari</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header text-white bg-primary">Data Pasien</div>
            <div class="card-body">
                <div id="table-pasien"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { TabulatorFull as Tabulator } from 'tabulator-tables'

export default{
    data() {
        return {
            data_pasien: [],
            filter: {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: ''
            },
            table: null
        }
    },
    created() {
        this.filter.page = this.$route.query.page ?? 1
    },
    mounted() {
        this.getAllPasien()
    },
    methods: {
        getAllPasien(){
            const uri = `/api/check-in/get-all?tanggal_dari=${this.filter.tanggal_dari}&tanggal_sampai=${this.filter.tanggal_sampai}&search=${this.filter.search}`
            
            const element = document.getElementById('table-pasien')

            this.table = new Tabulator(element, {
                layout: 'fitColumns',
                pagination: 'true',
                paginationMode: 'remote',
                paginationSize: 10,
                paginationSizeSelector:[10, 25, 50, 100, true],
                dataLoader: this.ajaxLoader,
                ajaxURL: uri,
                ajaxResponse: this.AjaxResponse,
                sortMode: 'remote',
                filterMode: 'remote',

                columns: [
                    {title: 'No. Rekam Medis', field: 'Medrec'},
                    {title: 'Nama Pasien', field: 'Firstname'},
                    {title: 'No. Registrasi', field: 'Regno'},
                    {title: 'Poli Asal', field: 'NMPoli'},
                    {title: 'DPJP', field: 'NmDoc'},
                    {title: 'Waktu Check In', field: 'date_check_in'},
                    {title: 'Waktu Selesai Pelayanan', field: 'date_check_out'},

                ]
            })
        },
        ajaxLoader() {
            // set loading screen
        },
        AjaxResponse(url, params, response) {
            return response.data_pasien
        },
        resetFilters(){
            this.filter = {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
                page: 1,
            }

            this.getAllPasien()
        }
    }
}
</script>